import { useMemo } from 'react';
import {
  useDeleteQrCodeMutation,
  QrCodePixelShare,
} from '../api';
import { useEntityActions, BaseEntityAction } from '@hooks/useEntityActions';

// Forward declare the type to avoid circular dependency
export type QrCodeAction = BaseEntityAction;

// Define getEntityId outside to ensure stability
const getEntityId = (qrCode: QrCodePixelShare) => qrCode.id;

export const useQrCodeActions = () => {
  const actions = useEntityActions<QrCodePixelShare, QrCodeAction>({
    entityName: 'QR Code Pixel Share',
    displayProperty: 'full_name',
    deleteMutation: useDeleteQrCodeMutation,
    getEntityId,
  });

  return useMemo(() => actions, [actions]);
}; 